// Exams' build flag and public paths, with no imports: App and the
// always-loaded shell import only this, so a flag-off build carries none of
// the feature's code in its main bundle (every Exams page is lazy).
//
// Code that ships to everyone (App, Header2, MainSidebar, …) tests the flag as
// the literal `process.env.REACT_APP_EXAMS === 'on'` (the same test as
// isExamsEnabled()) and puts every Exams import() behind it: Parcel inlines
// the variable at build time, folds the test to false in a flag-off build and
// drops the guarded code, the import and its chunk. A call to isExamsEnabled()
// from another module can't be folded that way. Same pattern as
// utils/teacherLoopGate.js.

export const isExamsEnabled = () => process.env.REACT_APP_EXAMS === 'on';

/**
 * What a flag-guarded React.lazy loads when the flag is off (never rendered
 * then; it keeps the loader a valid module promise):
 *   React.lazy(() => process.env.REACT_APP_EXAMS === 'on'
 *     ? import('./X') : noExamsModule())
 */
const Nothing = () => null;
export const noExamsModule = () => Promise.resolve({ default: Nothing });

// The public report pages (#/r/<token>, #/sr/<token>): no account, no shell.
export const EXAM_PUBLIC_PATHS = ['/r/', '/sr/'];

/** Paths the app serves without a login, added to App.jsx publicPaths. */
export const examsPublicPaths = () =>
  isExamsEnabled() ? [...EXAM_PUBLIC_PATHS] : [];

/** A public exam report page, with the build flag on. */
export const isExamsPublicPath = (pathname) =>
  isExamsEnabled() &&
  EXAM_PUBLIC_PATHS.some((prefix) => String(pathname || '').startsWith(prefix));

/** Inside the exam wizard (/exams/<id>/…, /exams/new), not billing pages. */
export const isExamsWizardPath = (pathname) =>
  /^\/exams\/(?!billing\/)[^/]+/.test(String(pathname || ''));
